import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axios from '../../../utils/axios';
import { AxiosError, AxiosResponse } from 'axios';
import { FetchResellerOrderSettles } from './fetch-reseller-order-settles';

export namespace SuccessResellerOrderSettle {
  export type RequestType = {
    orderSettleId: number;
  };

  export const useMutate = ({
    onSuccess,
    ...options
  }: UseMutationOptions<AxiosResponse, AxiosError, RequestType> = {}) => {
    const { modify } = FetchResellerOrderSettles.useModify();

    const mutation = useMutation(
      ({ orderSettleId }) => {
        return axios.patch(
          `/reseller-order-settles/${orderSettleId}/success-settle`
        );
      },
      {
        onSuccess: (...rest) => {
          modify({
            id: rest[1].orderSettleId,
            isSettle: true
          });
          onSuccess?.(...rest);
        },
        ...options
      }
    );

    return mutation;
  };
}
